export const subtitles = {
    "1": {
        "startTime": 2.93,
        "endTime": 11.01,
        "transcript": "Qivrunrilkumegnuk piyanritarpuk tauna ungungssiq tauna nerrleq.",
        "translation": "Were we not sad over our loss, we wouldn't have killed that animal that ate."
    },
    "2": {
        "startTime": 11.955,
        "endTime": 15.355,
        "transcript": "Kingumek nerluku nangluku yuut.",
        "translation": "Afterwards, the people ate the rest of it."
    },
    "3": {
        "startTime": 17.16,
        "endTime": 18.39,
        "transcript": "Way in the...",
        "translation": "Way in the..."
    },
    "4": {
        "startTime": 20.17,
        "endTime": 28.6,
        "transcript": "Nerluku-w' tua-i wangkuta-llu nerluku tauna nerrleq tauna. Neqkailamta allamek tua-i nerluku.",
        "translation": "We also ate what had been eaten. We ate it because we had nothing else to eat."
    },
    "5": {
        "startTime": 31.53,
        "endTime": 35.83,
        "transcript": "Pissuryarat pagkut pagaani ingrini amllertut.",
        "translation": "There's a lot of places to hunt up there in the mountains."
    },
    "6": {
        "startTime": 36.895,
        "endTime": 45.135,
        "transcript": "Waniwa ciuqliq: Evsairniit pissuryaraugut.",
        "translation": "Here's the first: Evsairniit is a place to hunt."
    },
    "7": {
        "startTime": 46.17,
        "endTime": 55.0,
        "transcript": "Tua-i-llu tungii: Nacarkarniarmek pissuryaraq mayuumayaraat.",
        "translation": "And the next: a hunting place is going up from Nacarkarniar."
    },
    "8": {
        "startTime": 55.54,
        "endTime": 60.93,
        "transcript": "Tua-llu pingayuak: Ilutuqacuk, wiinga-w' nunautekeka.",
        "translation": "And the third: Ilutuqacuk, my lands."
    },
    "9": {
        "startTime": 60.98,
        "endTime": 64.19,
        "transcript": "(Kangerpakmailianek-llu imkunek.) Yaa.",
        "translation": "(And from Kangerpakmailiat.) Yes."
    },
    "10": {
        "startTime": 66.97,
        "endTime": 72.31,
        "transcript": "Naqerpak-wa. Nurtuutaraq-wa.",
        "translation": "Then Naqerpak. Then Nurtuutaraq."
    },
    "11": {
        "startTime": 72.965,
        "endTime": 75.815,
        "transcript": "Lots of camps [?] upriver.",
        "translation": "Lots of camps [?] upriver."
    },
    "12": {
        "startTime": 75.815,
        "endTime": 78.285,
        "transcript": "Qanirtuum-wa Qagatii.",
        "translation": "Then Qanirtuum Qagatii."
    },
    "13": {
        "startTime": 78.285,
        "endTime": 81.675,
        "transcript": "Way up there, [?].",
        "translation": "Way of up there, [?]."
    },
    "14": {
        "startTime": 81.695,
        "endTime": 93.665,
        "transcript": "Naqerpagmek tauna pilaraat wavet Kuinerram Qagatiinun ayagyaraq.",
        "translation": "They call it Naqerpak where it goes it goes here to Kuinerram Qagatii."
    },
    "15": {
        "startTime": 96.275,
        "endTime": 104.385,
        "transcript": "Kuinerram-llu Qagatiini waniw' walirnermi nanvam keluani Equgniilngurni cali pissuryaraq tauna.",
        "translation": "And on this side of Kuinerram Qagatii, inland from the lake, Equgniilnguut is also hunting grounds."
    },
    "16": {
        "startTime": 104.795,
        "endTime": 112.325,
        "transcript": "Una-wa cali uani igyaraani pissuryaraq cali nutaan pissuumayarat.",
        "translation": "And then downriver near its mouth, there's a hunting ground that they hunt in for a long time."
    },
    "17": {
        "startTime": 112.495,
        "endTime": 119.015,
        "transcript": "Ukut-llu Kuigglugmiut tuavet uksuarmi ayalartut nangluteng angutet.",
        "translation": "And then every single man from Kuiggluk goes there in the fall."
    },
    "18": {
        "startTime": 119.82,
        "endTime": 124.87,
        "transcript": "Tua-i Alussistuaqata'arqata tau͡gaam tekitaqluteng.",
        "translation": "They would only return when Christmas was nigh."
    },
    "19": {
        "startTime": 127.69,
        "endTime": 140.03,
        "transcript": "Pika-i-ll' pikna Naqailngurmek pilaqiit cali pissuryaraq tauna pissuumayaraat.",
        "translation": "And up there where they call it Naqailnguq is also a hunting ground where they hunt for a long time."
    },
    "20": {
        "startTime": 148.525,
        "endTime": 153.765,
        "transcript": "Pissuryarat tua-i pagaani tamalkuita nallunritanka.",
        "translation": "I know all of the hunting grounds up there."
    },
    "21": {
        "startTime": 157.52,
        "endTime": 164.73,
        "transcript": "Ingriúrlurmek aterluni. Ingriúrlurmek aterluni ingriq.",
        "translation": "It's called Ingriúrluq. The mountain is called Ingriúrluq."
    },
    "22": {
        "startTime": 165.22,
        "endTime": 170.77,
        "transcript": "Una-wa uatiini Elngurtuliarmek cali aterluni.",
        "translation": "And downriver, it's called Elngurtuliar."
    },
    "23": {
        "startTime": 170.82,
        "endTime": 173.82,
        "transcript": "Ukut-wa akiatni Qikertat.",
        "translation": "And across from them is Qikertat [Islands]."
    },
    "24": {
        "startTime": 174.285,
        "endTime": 184.725,
        "transcript": "Ukuk-wa taum Elngurtuliaraam keluani Napanguliignek aterlutek qiurek qulmun napalutek.",
        "translation": "And these two inland from Elngurtuliar, the upright boulders are called Napanguliik."
    },
    "25": {
        "startTime": 185.62,
        "endTime": 196.05,
        "transcript": "Una-wa aciagni Ingrilukaak-gguq. Tua-lli tua-i cali taukuk pissuryaraulutek.",
        "translation": "And beneath them, they call them Ingrilukaak. That is also a hunting ground."
    },
    "26": {
        "startTime": 196.83,
        "endTime": 206.47,
        "transcript": "Tauna-llu pikani akiani Iluvagtuq. Iluvagtuq-gguq. Cali pissuryarauluni tauna.",
        "translation": "And then up there across from it is Iluvagtuq. They call it Iluvagtuq. That's also a hunting ground."
    },
    "27": {
        "startTime": 207.205,
        "endTime": 217.645,
        "transcript": "Tua-i-llu kiatiini yaani Ulurrugnaq-gguq ingriq uverrluni tua-i, uverqurluni.",
        "translation": "And then upriver and to the side, the moutnain Ulurrugnaq is steep."
    },
    "28": {
        "startTime": 218.27,
        "endTime": 220.78,
        "transcript": "Uverqurluni ketmun.",
        "translation": "It's slope goes toward the water."
    },
    "29": {
        "startTime": 221.49,
        "endTime": 227.18,
        "transcript": "Qukaani-wa can'gurneq una. Can'get naumaluteng qagkut.",
        "translation": "And in the center is a grassy area. The grass grows upriver."
    },
    "30": {
        "startTime": 227.78,
        "endTime": 235.87,
        "transcript": "Taum-llu qukaani naumalriim tamakut-am, ciuqliit qanlartut",
        "translation": "In the center of those plants, the elders say"
    },
    "31": {
        "startTime": 236.22,
        "endTime": 239.85,
        "transcript": "Tauna-gguq yuk mayullruuq.",
        "translation": "They say that a person went up."
    },
    "32": {
        "startTime": 240.02,
        "endTime": 248.84,
        "transcript": "Tua-i-llu qukaqerluni aaqilluni tua-i. Aciminun-ll' uyungluni aaqilluni.",
        "translation": "And then when he reached the middle, he became wary. He was wary and squat down below."
    },
    "33": {
        "startTime": 249.415,
        "endTime": 252.525,
        "transcript": "Qaill' pisciiganani, ayagciiganani.",
        "translation": "He couldn't do anything, couldn't go on."
    },
    "34": {
        "startTime": 253.235,
        "endTime": 259.785,
        "transcript": "Tua-i-gguq pika-i qukaa can'gurnerulartuq ingrim pik'um man'a tekilluku.",
        "translation": "They say that the center of that mountain up there is a grassy area to this day."
    },
    "35": {
        "startTime": 262.525,
        "endTime": 273.595,
        "transcript": "Tua-ll' kiatiini, kiatiini Atsartuliar-gguq ingricuar angevkenani. Cali pissuumayaraq.",
        "translation": "Then upriver, they call the small mountain Atsartuliar. It's also a hunting ground."
    },
    "36": {
        "startTime": 274.415,
        "endTime": 286.215,
        "transcript": "Tua-i-llu taum ingricuaraam cali keluani kuignayuk, kuignayuk kelutmun Kuignayugpagmek aterluni.",
        "translation": "And the the small river inland from that small mountain, the small river going inland is called Kuignayugpak."
    },
    "37": {
        "startTime": 286.75,
        "endTime": 291.7,
        "transcript": "Nutaan tauna cali pissuryaraq, pissuumayaraq.",
        "translation": "Now that is a hunting ground where they hunt for a long time."
    },
    "38": {
        "startTime": 292.66,
        "endTime": 300.41,
        "transcript": "Tua-llu Qanirtuum Kuiganun waniw' tekiteqatartua.",
        "translation": "And then, I'm going to go to the Qanirtuk River."
    },
    "39": {
        "startTime": 301.57,
        "endTime": 312.15,
        "transcript": "Qanirtuum Kuigan ceńiini... ingriq ima tanem im' camek pilaqiit?",
        "translation": "On the banks of the Qanirtuk River... what do they call the mountain again?"
    },
    "40": {
        "startTime": 313.175,
        "endTime": 318.515,
        "transcript": "Ulurrugnaq. Tauna cali tua-i pissuumayaraq.",
        "translation": "Ulurrugnaq. That's also a hunting ground."
    },
    "41": {
        "startTime": 320.2,
        "endTime": 327.95,
        "transcript": "Tauna-llu kiatiini... cagnek im'? Cayagtuli? Nuu.",
        "translation": "And upriver from there... what is it again? Cayagtuli? No."
    },
    "42": {
        "startTime": 330.37,
        "endTime": 334.65,
        "transcript": "Nallukenka wiinga. Nanglliuq?",
        "translation": "I don't know them. Is that all?"
    },
    "43": {
        "startTime": 334.805,
        "endTime": 337.675,
        "transcript": "Nuu, nangekstaitut. Nangyugnaitut.",
        "translation": "No, there's more. There's a lot more."
    },
    "44": {
        "startTime": 339.915,
        "endTime": 345.955,
        "transcript": "Tua-ll' pikani Ircaqurrnaq.",
        "translation": "And then up there is Ircaqurrnaq."
    },
    "45": {
        "startTime": 346.73,
        "endTime": 351.02,
        "transcript": "Cali pissuryarauguq tauna. Ircaqurrnamek aterluni.",
        "translation": "That's also a hunting ground. It's called Ircaqurrnaq."
    },
    "46": {
        "startTime": 351.65,
        "endTime": 359.57,
        "transcript": "Tua-llu wani ketiini ingricuar ayuqii. Ircaqurrnayagarmek aterluni.",
        "translation": "And then toward the water, there's a similar mountain. It's called Ircaqurrnayagaq."
    },
    "47": {
        "startTime": 359.955,
        "endTime": 372.535,
        "transcript": "Tua-ll' yaani kiatnii Evsaiksugaak. Cali tamaani pissutuluteng taum yaaqsinrilkiini.",
        "translation": "And then over and upriver are Evsiaksugaak. They also hunt not far from there."
    },
    "48": {
        "startTime": 375.66,
        "endTime": 380.26,
        "transcript": "Wani-llu Qerrirtaq.",
        "translation": "And here is Qerrirtaq."
    },
    "49": {
        "startTime": 380.295,
        "endTime": 385.575,
        "transcript": "Qerrirtami cali tuani pissuryarauguq, tang nutaan pissuumayarauluni.",
        "translation": "Qerrirtaq is also a hunting ground where they can hunt for a long time."
    },
    "50": {
        "startTime": 385.92,
        "endTime": 390.43,
        "transcript": "Tua-i-llu kiani Cingikeggliq.",
        "translation": "And then upriver is Cingikeggliq."
    },
    "51": {
        "startTime": 392.4,
        "endTime": 396.97,
        "transcript": "Cingikegglimek aterluni ingriq cingickeggluni qulmun.",
        "translation": "The mountin with a sharp upward summit is called Cingikeggliq."
    },
    "52": {
        "startTime": 397.32,
        "endTime": 404.7,
        "transcript": "Tua-ll' ukatiini Kuigglugmun atrarluni ingriq Canirngalria-gguq.",
        "translation": "And on this side, they mountain going down to Kuiggluk is named Canirngalria."
    },
    "53": {
        "startTime": 405.775,
        "endTime": 411.635,
        "transcript": "Tua-llu taum akiani Qupun. Quputmek aterluni.",
        "translation": "And then on the other side is Qupun. It's called Qupun."
    },
    "54": {
        "startTime": 412.49,
        "endTime": 418.17,
        "transcript": "Yaani-w' iquani Canyon-aamek aterluni Kuignayuggaq cali.",
        "translation": "And then over at the end, it's name is Canyon, Kuignayuggaq."
    },
    "55": {
        "startTime": 420.125,
        "endTime": 426.255,
        "transcript": "Wani-llu akiani tauna Nacarkarniarun.",
        "translation": "And on the other side here is Nacarkarniarun."
    },
    "56": {
        "startTime": 426.505,
        "endTime": 430.495,
        "transcript": "Nutaan pissuumayaraat mayuumalriit.",
        "translation": "Now that place where they go up is a hunting ground."
    },
    "57": {
        "startTime": 431.225,
        "endTime": 437.145,
        "transcript": "Tua-llu cali taum Nacarkarniarutem akiani...",
        "translation": "And then on the other side of Nacarkarniarun..."
    },
    "58": {
        "startTime": 437.16,
        "endTime": 439.15,
        "transcript": "Unaten pivkenaku.",
        "translation": "[?Don't use your hand.]"
    },
    "59": {
        "startTime": 439.15,
        "endTime": 439.9,
        "transcript": "Aa?",
        "translation": "What?"
    },
    "60": {
        "startTime": 440.4,
        "endTime": 443.26,
        "transcript": "Evsairniik. Evsiarniik-gguq.",
        "translation": "Evsairniik. They call it Evsairniik."
    },
    "61": {
        "startTime": 443.505,
        "endTime": 448.205,
        "transcript": "Tua-i cali tauku pissuumayarak tua-i taukuk ak'anun.",
        "translation": "They also hunt there for a long time."
    },
    "62": {
        "startTime": 454.65,
        "endTime": 460.8,
        "transcript": "Yeah, take a break, rest, stop for a minute. Yeah, stop. (Ii-i, taqsukuvet.)",
        "translation": "Yeah, take a break, rest, stop for a mintue. Yeah, stop. (Okay, you can stop.)"
    },
    "63": {
        "startTime": 461.26,
        "endTime": 465.68,
        "transcript": "Au͡gkut tua-i pissumayarat tamalkuita ava-i qalarutkuraranka.",
        "translation": "I've just talked about all of those hunting grounds."
    },
    "64": {
        "startTime": 465.695,
        "endTime": 469.225,
        "transcript": "I don't know how to talk Kass'aq.",
        "translation": "I don't know how to talk in English."
    },
    "65": {
        "startTime": 471.255,
        "endTime": 476.655,
        "transcript": "Has he mentioned any stories of big creatures?",
        "translation": "Has he mentioned any stories of big creatures?"
    },
    "66": {
        "startTime": 477.17,
        "endTime": 478.69,
        "transcript": "Neqerpangqertuq.",
        "translation": "It has big fish."
    },
    "67": {
        "startTime": 478.725,
        "endTime": 480.985,
        "transcript": "Yaa, qanrutkaa ava-i. He already.",
        "translation": "Yes, he just talked about it. He already did."
    },
    "68": {
        "startTime": 481.19,
        "endTime": 489.92,
        "transcript": "Did he talk about, anything about the skeleton, ribs, skeletons on the beach?",
        "translation": "Did he talk about, anything about the skeleton, ribs, skeletons on the beach?"
    },
    "69": {
        "startTime": 490.31,
        "endTime": 491.26,
        "transcript": "It's long time.",
        "translation": "It's long time."
    },
    "70": {
        "startTime": 491.27,
        "endTime": 496.47,
        "transcript": "Yaa, did he talk about that though? (Yaa.) The skeletons on the beach? (Yaa.) Okay.",
        "translation": "Okay, did he talk about that though? (Yes.) The skeletons on the beach? (Yes.) Okay."
    },
    "71": {
        "startTime": 497.165,
        "endTime": 504.005,
        "transcript": "[?] the father, her father, long time, the bones.",
        "translation": "[?] the father, her father, long time, the bones."
    },
    "72": {
        "startTime": 504.48,
        "endTime": 506.75,
        "transcript": "White bones? (Yaa, yaa.)",
        "translation": "White bones? (Yes, yes.)"
    },
    "73": {
        "startTime": 507.23,
        "endTime": 513.34,
        "transcript": "He get big hole. (Right.) In and out, the kids are playing there.",
        "translation": "He get big hole. (Right.) In and out, the kids are playing there."
    },
    "74": {
        "startTime": 513.34,
        "endTime": 514.53,
        "transcript": "That's the story we heard.",
        "translation": "That's the story we heard."
    },
    "75": {
        "startTime": 517.75,
        "endTime": 524.15,
        "transcript": "She said long grass, that he's on ground place, that old place.",
        "translation": "She said long grass, that's he's on ground place, that old place."
    },
    "76": {
        "startTime": 524.385,
        "endTime": 528.015,
        "transcript": "Do you know which side of the lake those were on? North side?",
        "translation": "Do you know which side of the lake those were on? North side?"
    },
    "77": {
        "startTime": 528.515,
        "endTime": 531.305,
        "transcript": "Nuu. (South side?) Kuiggluk side.",
        "translation": "No. (South side?) Kwethluk side."
    },
    "78": {
        "startTime": 531.445,
        "endTime": 532.855,
        "transcript": "Kwethluk side of the lake?",
        "translation": "Kwethluk side of the lake?"
    },
    "79": {
        "startTime": 532.865,
        "endTime": 534.365,
        "transcript": "That's east side?",
        "translation": "That's east side?"
    },
    "80": {
        "startTime": 536.065,
        "endTime": 536.585,
        "transcript": "Yaa.",
        "translation": "Yaa."
    },
    "81": {
        "startTime": 536.6,
        "endTime": 538.74,
        "transcript": "Ukatmun caumaluni waten. Yaa.",
        "translation": "It faces this side. Yes."
    },
    "82": {
        "startTime": 538.755,
        "endTime": 543.05,
        "transcript": "Kiillaraliin, Heart Lake, Kuiggluk, this side.",
        "translation": "Kiillaraliin, Heart Lake, Kwethluk, this side."
    },
    "83": {
        "startTime": 543.05,
        "endTime": 545.75,
        "transcript": "This side, that's where the bones were? (Ii-i.)",
        "translation": "This side, that's where the bones were? (Yes.)"
    },
    "84": {
        "startTime": 546.975,
        "endTime": 551.035,
        "transcript": "Yaa, tua-i nauw' imna map-an? I'll show you. Nauw' im' map-an?",
        "translation": "Yes, where your map? I'lls how you. Where's your map?"
    },
    "85": {
        "startTime": 551.05,
        "endTime": 555.68,
        "transcript": "Okay, George can you get that? It's back in there, top one.",
        "translation": "Okay, George can you get that? It's back in there, top one."
    },
    "86": {
        "startTime": 558.96,
        "endTime": 564.56,
        "transcript": "Tunglirnera map-am, Kuiggluum tungiinun imna waten iciw' ayuqelria?",
        "translation": "Toward it on the map, you know it goes like this toward Kwethluk?"
    },
    "87": {
        "startTime": 575.235,
        "endTime": 577.955,
        "transcript": "Right or left? Right?",
        "translation": "Right or left? Right?"
    },
    "88": {
        "startTime": 578.92,
        "endTime": 583.01,
        "transcript": "Nauw' im' Kuiggluk. Maa-i tang Kuiggluk.",
        "translation": "Where' Kwethluk again? Here's Kwethluk."
    },
    "89": {
        "startTime": 584.01,
        "endTime": 586.32,
        "transcript": "Yaa, it's this side.",
        "translation": "Yes, it's this side."
    },
    "90": {
        "startTime": 587.57,
        "endTime": 589.57,
        "transcript": "We always stay this side.",
        "translation": "We always stay this side."
    },
    "91": {
        "startTime": 590.585,
        "endTime": 592.225,
        "transcript": "Kuikayak ava-i.",
        "translation": "There's Kuikayak over there."
    },
    "92": {
        "startTime": 592.34,
        "endTime": 593.49,
        "transcript": "Can you this aloud?",
        "translation": "Can you say this aloud?"
    },
    "93": {
        "startTime": 593.49,
        "endTime": 594.97,
        "transcript": "Kuikayak maa-i.",
        "translation": "Here's Kuikayak."
    },
    "94": {
        "startTime": 594.975,
        "endTime": 598.845,
        "transcript": "Ii-i. Crooked Creek Mountain. Yaa, waniwa.",
        "translation": "Yes. Crooked Creek Mountain. Yes, here it is."
    },
    "95": {
        "startTime": 608.525,
        "endTime": 612.955,
        "transcript": "Killalin nauwa? Maa-i tang.",
        "translation": "Where's Killalin? Here it is."
    },
    "96": {
        "startTime": 615.375,
        "endTime": 618.455,
        "transcript": "Kuik ava-i... (Kuigceńaq waniwa.)",
        "translation": "The river over there... (Here's Kuigceńaq.)"
    },
    "97": {
        "startTime": 620.4,
        "endTime": 623.66,
        "transcript": "Upper Fall-aq Igceńaq, Qurrlurta.",
        "translation": "Upper Fall is Igceńaq, Qurrlurta."
    },
    "98": {
        "startTime": 623.885,
        "endTime": 626.185,
        "transcript": "(Yaa.) Eskimo name, Qurrlurta.",
        "translation": "(Yes.) Eskimo name, Qurrlurta."
    },
    "99": {
        "startTime": 627.72,
        "endTime": 629.96,
        "transcript": "Taryaqvagtuli waniwa.",
        "translation": "Here's Taryaqvagtuli."
    },
    "100": {
        "startTime": 634.935,
        "endTime": 639.455,
        "transcript": "Yaa, waniwa-w' tua-i kanani walirnerani.",
        "translation": "Yes, here it is down there on this side."
    },
    "101": {
        "startTime": 640.33,
        "endTime": 643.96,
        "transcript": "Walirneranetuq wani. (Yaa, ukalirneranetuq tuani.)",
        "translation": "It's on this side. (Yes, it's there on this side.)"
    },
    "102": {
        "startTime": 646.555,
        "endTime": 650.275,
        "transcript": "Evon Qugg'aq, [?].",
        "translation": "Evon Qugg'aq, [?]."
    },
    "103": {
        "startTime": 653.51,
        "endTime": 655.39,
        "transcript": "You know stories, or?",
        "translation": "You know stories, or?"
    },
    "104": {
        "startTime": 657.475,
        "endTime": 660.405,
        "transcript": "Nuu, it's older than.",
        "translation": "No, it's older than."
    },
    "105": {
        "startTime": 662.435,
        "endTime": 666.165,
        "transcript": "She's teaching for hunting, walking.",
        "translation": "She's teaching for hunting, walking."
    },
    "106": {
        "startTime": 666.585,
        "endTime": 669.935,
        "transcript": "No stove, just tent in the winter.",
        "translation": "No stove, just tent in the winter."
    },
    "107": {
        "startTime": 673.555,
        "endTime": 676.555,
        "transcript": "When you went to Heart, like, did you walk?",
        "translation": "When you went to Heart, like, did you walk?"
    },
    "108": {
        "startTime": 676.78,
        "endTime": 678.87,
        "transcript": "Nuu, by plane.",
        "translation": "No, by plane."
    },
    "109": {
        "startTime": 679.16,
        "endTime": 683.75,
        "transcript": "Oh, this time? Long time, a long time ago, though, did you walk?",
        "translation": "Oh, this time? Long time, a long time ago, though, did you walk?"
    },
    "110": {
        "startTime": 683.75,
        "endTime": 687.9,
        "transcript": "Dogs. (Dogs.) Dog team.",
        "translation": "Dogs. (Dogs.) Dog team."
    },
    "111": {
        "startTime": 688.62,
        "endTime": 690.66,
        "transcript": "She went Heart Lake in the winter?",
        "translation": "She went Heart Lake in the winter?"
    },
    "112": {
        "startTime": 691.425,
        "endTime": 695.435,
        "transcript": "Spring. (In the spring for the thaw?) Beaver hunting, that kind.",
        "translation": "Spring. (In the spring for the thaw?) Beaver hunting, that kind."
    },
    "113": {
        "startTime": 699.765,
        "endTime": 704.285,
        "transcript": "Now it's, fall-ami tau͡gaam this year.",
        "translation": "Now it's, only in the the fall this year."
    },
    "114": {
        "startTime": 704.58,
        "endTime": 709.96,
        "transcript": "How many years, that was long time. Her daughter went up there.",
        "translation": "How many years, that was long time. Her daughter went up there."
    },
    "115": {
        "startTime": 710.525,
        "endTime": 714.205,
        "transcript": "I think [?] sickness.",
        "translation": "I think [?] sickness."
    },
    "116": {
        "startTime": 716.1,
        "endTime": 717.8,
        "transcript": "They flew up this year?",
        "translation": "They flew up this year?"
    },
    "117": {
        "startTime": 725.815,
        "endTime": 733.145,
        "transcript": "Is the lake, the lake's good now? There's no big fish in the lake? It's good? No...",
        "translation": "Is the lake, the lake's good now? There's no big fish in the lake? It's good? No..."
    },
    "118": {
        "startTime": 734.055,
        "endTime": 739.515,
        "transcript": "She got lots of talaarit. Caulriit ima talaarit?",
        "translation": "She god lots of talaarit [rainbow trout]. What are talaarit again?"
    },
    "119": {
        "startTime": 744.91,
        "endTime": 747.19,
        "transcript": "Canek ima tam' pilaqait fish-at?",
        "translation": "What do they call those fish again?"
    },
    "120": {
        "startTime": 748.305,
        "endTime": 750.865,
        "transcript": "Kina? Kina?",
        "translation": "Who? Who?"
    },
    "121": {
        "startTime": 751.2,
        "endTime": 753.0,
        "transcript": "Trout-at-wa nanvani.",
        "translation": "The trout in lakes."
    },
    "122": {
        "startTime": 754.055,
        "endTime": 756.145,
        "transcript": "No big... (Citegnat.)",
        "translation": "No big... (Citegnat.)"
    },
    "123": {
        "startTime": 756.17,
        "endTime": 762.07,
        "transcript": "Small ones we're fishing. (Citegnat.) We're fishing, we're eating small ones.",
        "translation": "Small ones we're fishing. (Citegnat.) We're fishing, we're eating small ones."
    },
    "124": {
        "startTime": 762.175,
        "endTime": 764.925,
        "transcript": "But no creatures in there like the stories anymore.",
        "translation": "But no creatures in there like the stories anymore."
    },
    "125": {
        "startTime": 764.945,
        "endTime": 775.185,
        "transcript": "Sometime, her youngest brother, but way up from mountainside, he saw something bubbling the water.",
        "translation": "Sometime, her youngest brother, but way up from the moutnainside, he saw something bubbling the water."
    },
    "126": {
        "startTime": 775.87,
        "endTime": 779.82,
        "transcript": "And then he saw lots of spots.",
        "translation": "And then he saw lots of spots."
    },
    "127": {
        "startTime": 780.25,
        "endTime": 786.61,
        "transcript": "Down, way down, it's clear, you know, the clearest water?",
        "translation": "Down, way down, it's clear, you know, the clearest water?"
    },
    "128": {
        "startTime": 786.625,
        "endTime": 787.48,
        "transcript": "Clear water?",
        "translation": "Clear water?"
    },
    "129": {
        "startTime": 787.48,
        "endTime": 792.59,
        "transcript": "Yaa, way down there, he saw the spots, black.",
        "translation": "Yes, way down there, he saw the spots, black."
    },
    "130": {
        "startTime": 792.6,
        "endTime": 793.83,
        "transcript": "When was that?",
        "translation": "When was that?"
    },
    "131": {
        "startTime": 793.97,
        "endTime": 796.83,
        "transcript": "Almost jump up.",
        "translation": "Almost jump up."
    },
    "132": {
        "startTime": 797.115,
        "endTime": 798.475,
        "transcript": "This time? This trip?",
        "translation": "This time? This trip?"
    },
    "133": {
        "startTime": 798.48,
        "endTime": 803.53,
        "transcript": "Nuu, long time, her brother, when she was...",
        "translation": "No, long time, her brother, when she was..."
    },
    "134": {
        "startTime": 805.08,
        "endTime": 807.54,
        "transcript": "She's in hospital now.",
        "translation": "She's in hospital now."
    },
    "135": {
        "startTime": 809.105,
        "endTime": 813.045,
        "transcript": "So did people get scared and stop going there, or people always went there?",
        "translation": "So did people get scared and stop going there, or people always went there?"
    },
    "136": {
        "startTime": 813.25,
        "endTime": 817.31,
        "transcript": "But me, I'm scared I might eat airplane.",
        "translation": "But me, I'm scared I might eat airplane."
    },
    "137": {
        "startTime": 822.695,
        "endTime": 827.345,
        "transcript": "Really, I'm scared. We might eat.",
        "translation": "Really, I'm scared. We might eat."
    },
    "138": {
        "startTime": 828.195,
        "endTime": 840.075,
        "transcript": "You ever, you or Wassilie ever hear of a stone face on top of a mountain by Kiseralik?",
        "translation": "You ever, you or Wassilie ever hear of a stone face on top of a mountain by Kiseralik?"
    },
    "139": {
        "startTime": 840.62,
        "endTime": 842.47,
        "transcript": "Stone head, face?",
        "translation": "Stone head, face?"
    },
    "140": {
        "startTime": 842.63,
        "endTime": 845.49,
        "transcript": "Nuu, I never go there, Kiillaraliin.",
        "translation": "No, I never go there, Kiillaraliin."
    },
    "141": {
        "startTime": 845.5,
        "endTime": 852.445,
        "transcript": "Can you ask him? A stone head by Kiseralik? Does he know? Can you ask?",
        "translation": "Can you ask him? A stone head by Kiseralik? Does he know? Can you ask?"
    },
    "142": {
        "startTime": 853.245,
        "endTime": 853.925,
        "transcript": "What head?",
        "translation": "What head?"
    },
    "143": {
        "startTime": 854.17,
        "endTime": 857.3,
        "transcript": "Stone, rock, on top of a mountain.",
        "translation": "Stone, rock, on top of a mountain."
    },
    "144": {
        "startTime": 857.73,
        "endTime": 860.45,
        "transcript": "I think, nuu, nalluaqa.",
        "translation": "I think, no, I don't know it."
    },
    "145": {
        "startTime": 861.385,
        "endTime": 866.025,
        "transcript": "Did you know Old Man Reed had a mine up on the Kiseralik?",
        "translation": "Did you know Old Man Reed had a mine up on the Kiseralik?"
    },
    "146": {
        "startTime": 867.07,
        "endTime": 871.15,
        "transcript": "[?] I always went up, always [?].",
        "translation": "[?] I always went up, always [?]."
    },
    "147": {
        "startTime": 871.155,
        "endTime": 873.195,
        "transcript": "Only went up to...",
        "translation": "Only went up to..."
    },
    "148": {
        "startTime": 874.33,
        "endTime": 878.75,
        "transcript": "One time, he went up to Kiillaraliin, but always rain.",
        "translation": "One time, he wen tup to Kiillaraliin, but always rain."
    },
    "149": {
        "startTime": 879.815,
        "endTime": 891.375,
        "transcript": "Some stories we've had, the people go up to Kiseralik all the time, but they were afraid to go to Heart Lake, 'cause there's supposed to be a creature over there. So they never did go to Kiseralik, I mean, to Heart Lake.",
        "translation": "Some stories we've had, the people go up to Kiseralik all the time, but they were afraid to go to Heart Lake, 'cause there's supposed to be a creature over there. So they never did go to Kiseralik, I mean, to Heart Lake."
    },
    "150": {
        "startTime": 891.77,
        "endTime": 896.48,
        "transcript": "We talked to Fanny, Fanny. (Yaa.) Yaa.",
        "translation": "We talked to Fanny, Fanny. (Yes.) Yes."
    },
    "151": {
        "startTime": 896.84,
        "endTime": 903.76,
        "transcript": "When she was young, her brother, David Jackson?",
        "translation": "When she was young, her brother, David Jackson?"
    },
    "152": {
        "startTime": 903.78,
        "endTime": 907.065,
        "transcript": "Long time, she was up that way.",
        "translation": "Long time, she was up that way."
    },
    "153": {
        "startTime": 908.555,
        "endTime": 911.685,
        "transcript": "Atam, I'll show you Kiillaraliin. Take it.",
        "translation": "Look, I'll show you Kiillaraliin. Take it."
    }
};